<label>
  <app-body-sm [bold]="bold">
    <ng-content></ng-content>
    <span *ngIf="requiredField" class="asterisk">*</span>
  </app-body-sm>
</label>
